import type { SVGProps } from 'react';
const SvgViewHeadline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_headline_svg__a)">
      <path
        fill="currentColor"
        d="M4 15h16v-2H4v2Zm0 4h16v-2H4v2Zm0-8h16V9H4v2Zm0-6v2h16V5H4Z"
      />
    </g>
    <defs>
      <clipPath id="view_headline_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewHeadline;
